import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { TWD } from '../../../app/utils';
import { getDatasetInitCount } from '../../../features/aiBotSlice';
import Tip from '../../shared/Tip';

const useStyles = makeStyles(
  {
    root: {},
    dataset: {
      '& > span': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  },
  {
    name: 'NotEmbeddingTip',
  },
);

const NotEmbeddingTip = ({ pathKey }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { orgId, id } = useParams();

  const [data, setData] = useState({ web: 0, file: 0 });

  useEffect(() => {
    const fn = async () => {
      const response = await dispatch(getDatasetInitCount(orgId, id));

      setData(response);
    };

    fn();
  }, []);

  if (!data?.web && !data?.file) {
    return null;
  }

  return (
    <Tip
      className={classes.tip}
      title={t('aiBot:notEmbeddingTipTitle')}
      text={
        <div>
          <div className={classes.dataset}>
            {t('aiBot:notEmbeddingTipUrl', {
              num: TWD(data?.web || 0, false).format(),
            })}
            <span
              onClick={() => {
                history.push(`/${pathKey}/${orgId}/${id}/knowledge/addWeb`);
              }}
            >
              {t('aiBot:notEmbeddingTipGoto')}
            </span>
          </div>
          <div className={classes.dataset}>
            {t('aiBot:notEmbeddingTipfile', {
              num: TWD(data?.file || 0, false).format(),
            })}
            <span
              onClick={() => {
                history.push(`/${pathKey}/${orgId}/${id}/knowledge/addFile`);
              }}
            >
              {t('aiBot:notEmbeddingTipGoto')}
            </span>
          </div>
        </div>
      }
    />
  );
};

export default NotEmbeddingTip;
